// GENERATED by sdk/scripts/sync-idl.ts from programs/anyfee/idl/anyfee.json — do not edit by hand.
// Re-run `npm run sync-idl -w @anyfee/sdk` whenever the program's IDL changes.
import type { AccountDataLayout, InstructionLayout } from "./layout-types.ts";

export const IDL_PROGRAM_ADDRESS = "BixfaA4JmPvntZvGZwnqhHdoUQvEzZY6ZBMXCLgF3C9M";

export const INSTRUCTIONS = {
  bind: {
    name: "bind",
    accounts: [
      { name: "config" },
      { name: "vault", writable: true },
      { name: "instructions_sysvar", address: "Sysvar1nstructions1111111111111111111111111" },
    ],
    args: [
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
      { name: "claimant", type: "pubkey" },
      { name: "expires_at", type: "i64" },
    ],
  },
  cancel_rebind: {
    name: "cancel_rebind",
    accounts: [
      { name: "claimant", signer: true },
      { name: "vault", writable: true },
    ],
    args: [
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
    ],
  },
  claim_sol: {
    name: "claim_sol",
    accounts: [
      { name: "claimant", signer: true },
      { name: "vault", writable: true },
      { name: "destination", writable: true },
    ],
    args: [
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
    ],
  },
  claim_token: {
    name: "claim_token",
    accounts: [
      { name: "claimant", signer: true },
      { name: "config" },
      { name: "vault", writable: true },
      { name: "usdc_mint" },
      { name: "vault_token_account", writable: true },
      { name: "destination", writable: true },
      { name: "token_program", address: "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA" },
    ],
    args: [
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
    ],
  },
  close_tip: {
    name: "close_tip",
    accounts: [
      { name: "vault" },
      { name: "tip", writable: true },
      { name: "sender", writable: true },
    ],
    args: [
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
      { name: "tip_index", type: "u64" },
    ],
  },
  decline: {
    name: "decline",
    accounts: [
      { name: "claimant", signer: true },
      { name: "vault", writable: true },
    ],
    args: [
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
    ],
  },
  finalize_rebind: {
    name: "finalize_rebind",
    accounts: [
      { name: "config" },
      { name: "vault", writable: true },
    ],
    args: [
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
    ],
  },
  init_vault: {
    name: "init_vault",
    accounts: [
      { name: "payer", writable: true, signer: true },
      { name: "vault", writable: true },
      { name: "system_program", address: "11111111111111111111111111111111" },
    ],
    args: [
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
    ],
  },
  initialize: {
    name: "initialize",
    accounts: [
      { name: "admin", writable: true, signer: true },
      { name: "config", writable: true },
      { name: "program", address: "BixfaA4JmPvntZvGZwnqhHdoUQvEzZY6ZBMXCLgF3C9M" },
      { name: "program_data" },
      { name: "system_program", address: "11111111111111111111111111111111" },
    ],
    args: [
      { name: "attester", type: "pubkey" },
      { name: "usdc_mint", type: "pubkey" },
      { name: "refund_window_secs", type: "i64" },
      { name: "rebind_delay_secs", type: "i64" },
    ],
  },
  refund_tip: {
    name: "refund_tip",
    accounts: [
      { name: "config" },
      { name: "vault", writable: true },
      { name: "tip", writable: true },
      { name: "sender", writable: true },
    ],
    args: [
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
      { name: "tip_index", type: "u64" },
    ],
  },
  refund_tip_token: {
    name: "refund_tip_token",
    accounts: [
      { name: "config" },
      { name: "vault", writable: true },
      { name: "tip", writable: true },
      { name: "sender", writable: true },
      { name: "usdc_mint" },
      { name: "vault_token_account", writable: true },
      { name: "sender_token_account", writable: true },
      { name: "token_program", address: "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA" },
    ],
    args: [
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
      { name: "tip_index", type: "u64" },
    ],
  },
  set_config: {
    name: "set_config",
    accounts: [
      { name: "admin", signer: true },
      { name: "config", writable: true },
    ],
    args: [
      { name: "new_admin", type: { option: "pubkey" } },
      { name: "attester", type: { option: "pubkey" } },
      { name: "refund_window_secs", type: { option: "i64" } },
      { name: "rebind_delay_secs", type: { option: "i64" } },
      { name: "paused", type: { option: "bool" } },
    ],
  },
  tip_sol: {
    name: "tip_sol",
    accounts: [
      { name: "sender", writable: true, signer: true },
      { name: "config" },
      { name: "vault", writable: true },
      { name: "tip", writable: true },
      { name: "system_program", address: "11111111111111111111111111111111" },
    ],
    args: [
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
      { name: "amount", type: "u64" },
    ],
  },
  tip_token: {
    name: "tip_token",
    accounts: [
      { name: "sender", writable: true, signer: true },
      { name: "config" },
      { name: "vault", writable: true },
      { name: "tip", writable: true },
      { name: "usdc_mint" },
      { name: "sender_token_account", writable: true },
      { name: "vault_token_account", writable: true },
      { name: "token_program", address: "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA" },
      { name: "associated_token_program", address: "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL" },
      { name: "system_program", address: "11111111111111111111111111111111" },
    ],
    args: [
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
      { name: "amount", type: "u64" },
    ],
  },
} as const satisfies Record<string, InstructionLayout>;

export const ACCOUNTS = {
  Config: {
    name: "Config",
    fields: [
      { name: "admin", type: "pubkey" },
      { name: "attester", type: "pubkey" },
      { name: "usdc_mint", type: "pubkey" },
      { name: "refund_window_secs", type: "i64" },
      { name: "rebind_delay_secs", type: "i64" },
      { name: "paused", type: "bool" },
      { name: "bump", type: "u8" },
    ],
  },
  Tip: {
    name: "Tip",
    fields: [
      { name: "vault", type: "pubkey" },
      { name: "sender", type: "pubkey" },
      { name: "mint", type: "pubkey" },
      { name: "amount", type: "u64" },
      { name: "created_at", type: "i64" },
      { name: "epoch", type: "u64" },
      { name: "refunded", type: "bool" },
      { name: "bump", type: "u8" },
    ],
  },
  Vault: {
    name: "Vault",
    fields: [
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
      { name: "claimant", type: "pubkey" },
      { name: "pending_claimant", type: "pubkey" },
      { name: "pending_effective_at", type: "i64" },
      { name: "bound_at", type: "i64" },
      { name: "created_at", type: "i64" },
      { name: "declined", type: "bool" },
      { name: "claim_epoch", type: "u64" },
      { name: "tip_count", type: "u64" },
      { name: "outstanding_tip_lamports", type: "u64" },
      { name: "outstanding_tip_tokens", type: "u64" },
      { name: "total_claimed_lamports", type: "u64" },
      { name: "total_claimed_tokens", type: "u64" },
      { name: "bump", type: "u8" },
    ],
  },
} as const satisfies Record<string, AccountDataLayout>;

export const EVENTS = {
  Bound: {
    name: "Bound",
    fields: [
      { name: "vault", type: "pubkey" },
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
      { name: "claimant", type: "pubkey" },
    ],
  },
  Claimed: {
    name: "Claimed",
    fields: [
      { name: "vault", type: "pubkey" },
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
      { name: "claimant", type: "pubkey" },
      { name: "destination", type: "pubkey" },
      { name: "mint", type: "pubkey" },
      { name: "amount", type: "u64" },
      { name: "consumed_tips", type: "bool" },
      { name: "claim_epoch", type: "u64" },
    ],
  },
  ConfigInitialized: {
    name: "ConfigInitialized",
    fields: [
      { name: "admin", type: "pubkey" },
      { name: "attester", type: "pubkey" },
      { name: "usdc_mint", type: "pubkey" },
      { name: "refund_window_secs", type: "i64" },
      { name: "rebind_delay_secs", type: "i64" },
    ],
  },
  ConfigUpdated: {
    name: "ConfigUpdated",
    fields: [
      { name: "admin", type: "pubkey" },
      { name: "attester", type: "pubkey" },
      { name: "refund_window_secs", type: "i64" },
      { name: "rebind_delay_secs", type: "i64" },
      { name: "paused", type: "bool" },
    ],
  },
  Declined: {
    name: "Declined",
    fields: [
      { name: "vault", type: "pubkey" },
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
      { name: "claimant", type: "pubkey" },
    ],
  },
  RebindCancelled: {
    name: "RebindCancelled",
    fields: [
      { name: "vault", type: "pubkey" },
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
      { name: "claimant", type: "pubkey" },
      { name: "cancelled_claimant", type: "pubkey" },
    ],
  },
  RebindFinalized: {
    name: "RebindFinalized",
    fields: [
      { name: "vault", type: "pubkey" },
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
      { name: "old_claimant", type: "pubkey" },
      { name: "new_claimant", type: "pubkey" },
    ],
  },
  RebindRequested: {
    name: "RebindRequested",
    fields: [
      { name: "vault", type: "pubkey" },
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
      { name: "current_claimant", type: "pubkey" },
      { name: "pending_claimant", type: "pubkey" },
      { name: "effective_at", type: "i64" },
    ],
  },
  Refunded: {
    name: "Refunded",
    fields: [
      { name: "vault", type: "pubkey" },
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
      { name: "tip", type: "pubkey" },
      { name: "tip_index", type: "u64" },
      { name: "sender", type: "pubkey" },
      { name: "mint", type: "pubkey" },
      { name: "amount", type: "u64" },
    ],
  },
  TipClosed: {
    name: "TipClosed",
    fields: [
      { name: "vault", type: "pubkey" },
      { name: "tip", type: "pubkey" },
      { name: "tip_index", type: "u64" },
      { name: "sender", type: "pubkey" },
    ],
  },
  Tipped: {
    name: "Tipped",
    fields: [
      { name: "vault", type: "pubkey" },
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
      { name: "tip", type: "pubkey" },
      { name: "tip_index", type: "u64" },
      { name: "sender", type: "pubkey" },
      { name: "mint", type: "pubkey" },
      { name: "amount", type: "u64" },
      { name: "epoch", type: "u64" },
    ],
  },
  VaultInitialized: {
    name: "VaultInitialized",
    fields: [
      { name: "vault", type: "pubkey" },
      { name: "platform", type: "u8" },
      { name: "id", type: "u64" },
      { name: "prefunded_lamports", type: "u64" },
    ],
  },
} as const satisfies Record<string, AccountDataLayout>;

/** Custom program errors (Anchor codes start at 6000). */
export const PROGRAM_ERRORS: Record<number, { name: string; msg: string }> = {
  6000: { name: "VaultDeclined", msg: "Vault has been declined by its claimant; it accepts no new tips" },
  6001: { name: "Paused", msg: "Program is paused (tips, binds and rebind finalization are disabled)" },
  6002: { name: "NotClaimant", msg: "Signer is not the vault's claimant" },
  6003: { name: "BadAttestation", msg: "Attestation message does not match the expected bind message" },
  6004: { name: "AttestationExpired", msg: "Attestation has expired" },
  6005: { name: "RebindNotReady", msg: "Pending rebind is not effective yet" },
  6006: { name: "NothingToClaim", msg: "Nothing to claim" },
  6007: { name: "RefundNotYet", msg: "Tip is not refundable yet" },
  6008: { name: "TipAlreadySettled", msg: "Tip was already refunded or consumed by a claim" },
  6009: { name: "UnknownPlatform", msg: "Unknown platform" },
  6010: { name: "VaultUnbound", msg: "Vault is not bound to a claimant" },
  6011: { name: "NoPendingRebind", msg: "Vault has no pending rebind" },
  6012: { name: "AlreadyClaimant", msg: "Claimant is already bound to this vault" },
  6013: { name: "AlreadyDeclined", msg: "Vault is already declined" },
  6014: { name: "InvalidClaimant", msg: "Invalid claimant" },
  6015: { name: "ZeroAmount", msg: "Amount must be greater than zero" },
  6016: { name: "MathOverflow", msg: "Arithmetic overflow" },
  6017: { name: "InvalidConfig", msg: "Configuration value out of bounds" },
  6018: { name: "NotAdmin", msg: "Signer is not the admin" },
  6019: { name: "NotUpgradeAuthority", msg: "Signer is not the program's upgrade authority" },
  6020: { name: "MissingEd25519Instruction", msg: "The instruction before bind must be an Ed25519SigVerify instruction" },
  6021: { name: "MalformedEd25519Instruction", msg: "Malformed Ed25519SigVerify instruction (need exactly one signature, all offsets inside the same instruction)" },
  6022: { name: "WrongAttester", msg: "Attestation was not signed by the configured attester" },
  6023: { name: "NotRefundable", msg: "Tip is not refundable: the vault is bound and not declined" },
  6024: { name: "WrongTipKind", msg: "Wrong refund instruction for this tip's asset (use refund_tip for SOL, refund_tip_token for tokens)" },
  6025: { name: "TipNotConsumed", msg: "Tip has not been consumed by a claim" },
  6026: { name: "InvalidDestination", msg: "Invalid destination" },
  6027: { name: "InsufficientVaultBalance", msg: "Vault balance is below its reserved amount" },
};
